import { render, staticRenderFns } from "./VesselCommunicationChannel.vue?vue&type=template&id=589ef554"
import script from "./VesselCommunicationChannel.vue?vue&type=script&lang=js"
export * from "./VesselCommunicationChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports